import {
    combineReducers
} from "@reduxjs/toolkit";


import LoginReducer from "./auth/login/reducer";
import AccountReducer from "./auth/register/reducer";
import ProfileReducer from "./auth/profile/reducer";
import ForgetPasswordReducer from "./auth/forgetpwd/reducer";
import BusinessInfoReducer from './businessInfo/reducer'
import BureauReducer from './bureau/reducer'
import DashboardReducer from './dashboard/reducer'
import MobileViewReducer from './mobile-view/reducer'
import MobileViewListing from './mobile-view-listing/reducer.js'
import Profiles from './ads/reducer.js'
import adAnalyticsReducer from './adsAnalytics/reducer.js';
import analyticsReducer from './analytics/reducer.js';
import NotificationData from './notification/reducer.js'
import NotificationAll from './notificationAll/reducer.js'
import duplicateReducer from './DuplicateAd/reducer.js'
import GlobalReloadReducer from "./globalReload.js";
import GlobalLoaderReducer from './globalLoader/reducer.js';
// import authReducer from "./auth/login/reducer"

const rootReducer = combineReducers({

    Login: LoginReducer,
    Account: AccountReducer,
    Profile: ProfileReducer,
    ForgetPassword: ForgetPasswordReducer,
    BusinessInfoReducer: BusinessInfoReducer,
    Bureau: BureauReducer,
    Dashboard: DashboardReducer,
    MobileViewDashboard: MobileViewReducer,
    MobileViewListing: MobileViewListing,
    Profiles: Profiles,
    AdAnalytics: adAnalyticsReducer,
    Analytics: analyticsReducer,
    Notification: NotificationData,
    NotificationAll: NotificationAll,
    // Transaction: TransactionData,
    DuplicateAd: duplicateReducer,
    GlobalReload: GlobalReloadReducer,
    globalLoader: GlobalLoaderReducer
});



export default rootReducer